import { Admission } from "src/PackageClasses";
import { resourceClass } from "./class";
import { resourcegroupname } from "./resourcegroupname";
import { tag } from "./tag";
import { admission } from "./admission";

export interface resource {
  groupname:string;
  id: string;
  resourceId: string;    
  name: string;  
  useClasses: boolean;
  exclusive: boolean;
  eventid: string;
  concurrentUses: number;
  maxConcurrent: number;
  disabled: boolean;  
  venueId: string;  
  colour: string;
  orderindex: number;
  length: number;
  classes: resourceClass[];
  showonbooking: boolean;
  resources: resource[];
  isresourcecontainer: boolean;
  isconstructed: boolean;
  resourcegroupname: resourcegroupname;
  price: number;
  fixedprice: boolean;
  tags: tag[];
  resourcegroup: resourcegroupname;  
  selectionmode: string;  
  selectableresourcestrings: resource[];  
  startwhen:string;
  startTimeOffset: number;
  optional: boolean;
  quantityselector: string;
  quantity: number;
  mode: string;
  inline: boolean;
  ignore: boolean;
  admissions: admission[];
  inProgress: boolean;
  originatingid: string;
  wasoptional: boolean;
  wasselected: boolean;
  isupgrade: boolean;
  showinitinerary: boolean; 
  showondaysheet: boolean;
  cansplit: boolean;
  //Minutes per row when this resource is drawn on the day sheet. Absent or 0 means it follows
  //the venue's DefaultInterval. Optional so the resource literals built all over the app for
  //bookings, packages and upgrades do not all have to carry a day sheet concern.
  daysheetinterval?: number;
}

export class cResource implements resource {
  groupname:string;
  id: string;
  resourceId: string;    
  name: string;  
  useClasses: boolean;
  exclusive: boolean;
  eventid: string;
  concurrentUses: number;
  maxConcurrent: number;
  disabled: boolean;  
  venueId: string;  
  colour: string;
  orderindex: number;
  length: number;
  classes: resourceClass[];
  showonbooking: boolean;
  resources: resource[];
  isresourcecontainer: boolean;
  isconstructed: boolean;
  resourcegroupname: resourcegroupname;
  price: number;
  fixedprice: boolean;
  tags: tag[];
  resourcegroup: resourcegroupname;  
  selectionmode: string;  
  selectableresourcestrings: resource[];  
  startwhen:string;
  startTimeOffset: number;
  optional: boolean;
  quantityselector: string;
  quantity: number;
  mode: string;
  inline: boolean;
  ignore: boolean;
  admissions: admission[];
  inProgress: boolean;
  originatingid: string;
  wasoptional: boolean;
  wasselected: boolean;
  isupgrade: boolean;
  packageupgradeid: string;
  showinitinerary: boolean;
  showondaysheet: boolean;
  cansplit: boolean;
  daysheetinterval?: number;
}